import { atom } from "jotai"
import { PhotoRecord, PhotosViewState } from "@/lib/catalog"
import { store } from "./store"

export interface AppLoadingState {
	status: AppLoadingStatus
	progress?: number
	total?: number
}

export type AppLoadingStatus =
	| null
	| "opening"
	| "importing"
	| "batchApplying"
	| "exporting"
	| "calibrating"
	| "preparingCalibration"
	| "updatingProfile"

export type HomePageSection =
	| "my_account"
	| "ai_styles"
	| "projects"
	| "tutorials"
	| "support"
	| "settings"

export type GridSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9

export type PhotoId = string

export type ToolPanel = "edit" | "crop" | "masking" | "healing" | "people"

export type ExpandablePanel = "colormatch_samples"

export type WbOption = "as-shot" | "custom"

export interface AppState {
	showingHome: boolean
	showingFilmstrip: boolean
	showingOnboarding: boolean
	showingLeftPanel: boolean
	showingRightPanel: boolean
	photosView: PhotosViewState
	files: Record<PhotoId, File>
	photos: Record<PhotoId, PhotoRecord>
	currentPhotoId: PhotoId | null
	selectedPhotos: Set<PhotoId>
	gridSize: GridSize
	isFullscreen: boolean
	customOrder: Record<PhotoId, number>
	activeEditingToolPanel: ToolPanel | null
	expandedPanels: Record<string, boolean>
	leftExpandedPanel: ExpandablePanel | null
}

export const defaultEditingExpandedPanels = {
	info: true,
	presets_panel: false,
	user_presets_group: true,
	history: true,
	histogram: true,
	basic: true,
	lut: false,
	faces: true,
	ai_debug_info: true,
	measurement: false,
	taskperformance: false,
}

export const defaultCullingExpandedPanels = {
	info: true,
	histogram: false,
	faces: true,
	smart_culling: true,
	measurement: true,
	taskperformance: true,
}

export const defaultState: AppState = {
	showingHome: true,
	showingFilmstrip: true,
	showingOnboarding: false,
	showingLeftPanel: false,
	showingRightPanel: false,
	photosView: "focus",
	files: {},
	photos: {},
	selectedPhotos: new Set<PhotoId>(),
	currentPhotoId: null,
	gridSize: 5,
	isFullscreen: false,
	activeEditingToolPanel: "edit",
	customOrder: {},
	expandedPanels: defaultEditingExpandedPanels,
	leftExpandedPanel: null,
}

export const stateAtom = atom(defaultState)

export const resetToDefaultAppState = () => {
	store.set(stateAtom, defaultState)
}
